//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wx from 'weixin-js-sdk'; 
export default {
  name: 'pickup',
  components: {
  },
  data () {
    return {
      id:0,
      utoken:'',
      active:1,
      user:{
        uid:0,
        nickname:'',
        phone:'',
      },
      submitStatus:false,
    }
  },
  created(){
    this.config();
  },
  mounted(){
    // this.id = Number(this.$route.params.id);
    // this.changePop();
  
  },
  methods:{
    actived(e){
      this.active = e;
    },
    copy(val){
        this.$func.copy(val,event);
    },
    scanQRCode(){
        let that = this;
        wx.ready(()=> {
            wx.scanQRCode({
            needResult: 1,
            scanType: ["qrCode"],
            success: function (res) {
                setTimeout(()=>{
                    // that.formData[id] = res.resultStr.split(',')[1];
                    that.utoken = res.resultStr;
                    that.getUser();
                },300);
            }
            })
        });
        wx.error((res)=> {
            console.log(res)
            // alert(res.errMsg);
        })
    },  
    config(){
        let url = (window.location.href).split('#');
        if(url[0].indexOf('?') != '-1'){
            url = url[0].split('?');
        }
        this.$api.wxSign({url:url[0]}).then((res)=>{
            if(res){
                wx.config({
                    debug: false, 
                    appId: res.data.appId,
                    timestamp: res.data.timestamp,
                    nonceStr: res.data.nonceStr,
                    signature:res.data.signature,
                    jsApiList: [
                        "scanQRCode"
                    ]
                });
            }
        })
    },
    getUser(){
      let that = this;
      if(!this.utoken){
        that.$func.showToast('用户token无效');
        return ;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      that.$func.startLoading();
      this.$api.getUser({utoken:this.utoken}).then((res)=>{
        if(res){
          that.user = res.data;
          that.submitStatus = true;
          that.$func.endLoading();
        } 
      })  
    },
    submit(){
      let that = this;
      if(!this.user.uid){
        that.$func.showToast('用户信息不存在');
        return ;
      }
      if(!this.active){
        that.$func.showToast('请选择赠送数量');
        return ;
      }
      this.$func.confirm('确认操作？','提示',()=>{
        this.$api.submitActive({uid:this.user.uid,active:this.active}).then((res)=>{
          if(res){
              that.submitStatus = false;
              that.$func.showToast('操作成功，请用户前往小程序首页下拉刷新查看免洗商品');
              that.utoken = '';
              that.active = 0;
              that.user = {
                uid:0,
                nickname:'',
                phone:'',
              };
            } 
          })  
        })
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/active.vue